import { Box, Button, Center, Group, Title, rem, Modal, TextInput, Select, Tabs } from "@mantine/core";
import AddIcon from '@mui/icons-material/Add';
import { useDisclosure } from '@mantine/hooks';
import Vclinkstable from "../Components/Admin/Vclinkstable";
import { useState } from "react";
import { message } from "antd";
import { Adminauthcontexthooks } from "../Hooks/Adminauthcontexthooks";
import Firlinkstable from "../Components/Admin/Firlinktable";







const Links = () => {
    const { user } = Adminauthcontexthooks();
    const [opened, { open, close }] = useDisclosure(false);
    const [openedfirmodal, { open: openfirmodalopen, close: closefirmodal }] = useDisclosure(false);
    const [Inputlinks, setinputlinks] = useState({
        Personname: '',
        vclinks: '',
        roomno: '',
        designation: '',
        staffname: '',
        mobileno: '',
        emailid: ''
    });
    const [Firinputlinks, setfirinputlinks] = useState({
        firstate: '',
        firlink: ''
    });
    const [selectcourt, setselectcourt] = useState('')
    const [selectsubdistcourt, setselectsubdistcourt] = useState('')
    const [selectdist, setselectdist] = useState('')
    const [loading, setloading] = useState({
        subbtnloading: false,
    })
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setinputlinks({ ...Inputlinks, [name]: value });
    }
    const handle_firInputChange = (e) => {
        const { name, value } = e.target;
        setfirinputlinks({ ...Firinputlinks, [name]: value });
    }
    const GetVcLinks = async () => {
        await fetch('https://cdr-backend.onrender.com/get/vclinks', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            }

        });
    }
    const Uploadvclinks = async () => {
        const { Personname, vclinks, roomno, designation, staffname, mobileno, emailid } = Inputlinks;
        if (Personname === '' || vclinks === '' || selectcourt === '' || roomno === '' || designation === '') {
            message.error('Please fill all the fields');
            return;
        }
        if (selectcourt === 'Dist. court' && (selectsubdistcourt === '' || selectdist === '')) {
            message.error('Please select sub dist. court and district');
            return;
        }
        setloading({ subbtnloading: true })
        const res = await fetch('https://cdr-backend.onrender.com/upload/information-vclinks', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            },
            body: JSON.stringify({ Personname, vclinks, roomno, designation, staffname, mobileno, emailid, selectcourt, selectsubdistcourt, selectdist })
        });
        if (res.status === 201) {
            message.success('VC Link added successfully');
            setinputlinks({ Personname: '', vclinks: '' });
            setselectcourt('');
            setselectsubdistcourt('');
            setselectdist('');
            setloading({ subbtnloading: false });
            close();
            GetVcLinks();
            return;
        } else {
            message.error('Failed to add VC Link');
            setloading({ subbtnloading: false })
            return
        }
    }
    const GetFirLinks = async () => {
        await fetch('https://cdr-backend.onrender.com/get/firlinks', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            }

        });
    }
    const Uploadfirlinks = async () => {
        const { firstate, firlink } = Firinputlinks;
        if (firstate === '' || firlink === '') {
            message.error('Please fill all the fields');
            return;
        }
        setloading({ subbtnloading: true })
        const res = await fetch('https://cdr-backend.onrender.com/upload/information-firlinks', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            },
            body: JSON.stringify({ firstate, firlink })
        });
        if (res.status === 201) {
            message.success('Fir Link added successfully');
            setfirinputlinks({ firstate: '', firlink: '' });
            setloading({ subbtnloading: false });
            closefirmodal();
            GetFirLinks();
            return;
        } else {
            message.error('Failed to add Fir Link');
            setloading({ subbtnloading: false })
            return
        }
    }

    return (
        <>
            <Modal opened={opened} onClose={close} title="Add New VC Link" centered>
                <Select label="Select Court" placeholder="Pick value" data={['Supreme court', 'High court', 'Dist. court']} mt={'xs'} name="court" value={selectcourt} onChange={(value, option) => setselectcourt(value)} withAsterisk />
                {
                    selectcourt === 'Dist. court' && (<><Select label="Select Sub Dist. Court" placeholder="Pick value" data={['Tis Hazari courts', 'Rouse Avenue courts', 'Karkardooma courts', 'Patiala House courts', 'Rohini courts', 'Dwarka courts', 'Saket courts']} mt={'xs'} name="subdistcourt" value={selectsubdistcourt} onChange={(value, option) => setselectsubdistcourt(value)} withAsterisk />

                        <Select label="Select District" placeholder="Pick value" data={['Central Dist.', 'West Dist.', 'East Dist.', 'North East Dist.', 'Shahdara Dist.', 'New Delhi Dist.', 'North West Dist.', 'North Dist.', 'South West Dist.', 'South East Dist.', 'South Dist.']} mt={'xs'} name="district" value={selectdist} onChange={(value, option) => setselectdist(value)} withAsterisk />
                    </>
                    )
                }

                <TextInput label="Enter Room Number" placeholder="e.g. 503" radius={'lg'} name="roomno" value={Inputlinks.roomno} onChange={handleInputChange} withAsterisk mt={'xs'} />
                <TextInput label="Enter Name of the Judicial Officer" placeholder="e.g. Justice Ram Kumar" radius={'lg'} name="Personname" value={Inputlinks.Personname} onChange={handleInputChange} withAsterisk mt={'xs'} />
                <TextInput label="Enter Designation" placeholder="e.g. District Judge (Commercial Court) - 01" radius={'lg'} name="designation" value={Inputlinks.designation} onChange={handleInputChange} withAsterisk mt={'xs'} />
                <TextInput label="Enter Name of the staff " placeholder="e.g. Shyam Kumar" radius={'lg'} name="staffname" value={Inputlinks.staffname} onChange={handleInputChange} mt={'xs'} />
                <TextInput label="Enter Mobile No " placeholder="e.g. 9999999999" radius={'lg'} name="mobileno" value={Inputlinks.mobileno} onChange={handleInputChange} mt={'xs'} />
                <TextInput label="Enter E-mail ID for correspondance " placeholder="e.g. ramkumar@email.com" radius={'lg'} name="emailid" value={Inputlinks.emailid} onChange={handleInputChange} mt={'xs'} />
                <TextInput label="Enter vc link" placeholder="e.g. https://vclink.com" radius={'lg'} name="vclinks" value={Inputlinks.vclinks} onChange={handleInputChange} withAsterisk mt={'xs'} />
                <Button mt={'md'} color="lime" onClick={Uploadvclinks} loading={loading.subbtnloading} disabled={loading.subbtnloading}>Upload Information</Button>
            </Modal>
            <Modal opened={openedfirmodal} onClose={closefirmodal} title="Add New Fir Link" centered>
                <TextInput label="Enter State" placeholder="e.g. Delhi" radius={'lg'} name="firstate" value={Firinputlinks.firstate} onChange={handle_firInputChange} withAsterisk mt={'xs'} />
                
                <TextInput label="Enter fir link" placeholder="e.g. https://firdelhi.com" radius={'lg'} name="firlink" value={Firinputlinks.firlink} onChange={handle_firInputChange} withAsterisk mt={'xs'} />
                <Button mt={'md'} color="lime" onClick={Uploadfirlinks} loading={loading.subbtnloading} disabled={loading.subbtnloading}>Upload Information</Button>
            </Modal>
            <Tabs variant="pills" defaultValue="vclinks" mt={'md'}>
                <Tabs.List>
                    <Tabs.Tab value="vclinks" >
                        VC Links
                    </Tabs.Tab>
                    <Tabs.Tab value="fir">
                        Fir Links
                    </Tabs.Tab>
                    {/* <Tabs.Tab value="settings" leftSection={<IconSettings size={12} />}>
                        Settings
                    </Tabs.Tab> */}
                </Tabs.List>

                <Tabs.Panel value="vclinks">
                    <Center mt={'xs'}><Title c={'dimmed'}>VC Links</Title></Center>

                    <Group justify="flex-end" mt={'md'}>
                        <Button variant="light" color="indigo" leftSection={<AddIcon style={{ width: rem(14), height: rem(14) }} />} onClick={open}>Add VC Link</Button>
                    </Group>

                    <Box mt={'md'}>
                        <Vclinkstable />
                    </Box>
                </Tabs.Panel>

                <Tabs.Panel value="fir">
                    <Center mt={'xs'}><Title c={'dimmed'}>Fir Links</Title></Center>

                    <Group justify="flex-end" mt={'md'}>
                        <Button variant="light" color="indigo" leftSection={<AddIcon style={{ width: rem(14), height: rem(14) }} />} onClick={openfirmodalopen}>Add Fir Links</Button>
                    </Group>

                    <Box mt={'md'}>
                        <Firlinkstable />
                    </Box>
                </Tabs.Panel>

                {/* <Tabs.Panel value="settings">
                    Settings tab content
                </Tabs.Panel> */}
            </Tabs>


        </>
    )
}

export default Links;